"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Carousel_1 = require("./Carousel");
exports.default = Carousel_1.default;
//# sourceMappingURL=index.js.map